var _style, _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoDataFull(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EBEBEB;}\r\n\t.st1{fill:#E6E6E6;}\r\n\t.st2{fill:#F0F0F0;}\r\n\t.st3{fill:#FAFAFA;}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{opacity:0.6;fill:#EBEBEB;}\r\n\t.st6{fill:#F5F5F5;}\r\n\t.st7{fill:#E0E0E0;}\r\n\t.st8{display:none;}\r\n\t.st9{display:inline;}\r\n\t.st10{fill:#407BFF;}\r\n\t.st11{opacity:0.9;fill:#FFFFFF;}\r\n\t.st12{fill:#5633D1;}\r\n\t.st13{fill:#381FB2;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 404.19,
    className: "st0",
    width: 500,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 420.29,
    className: "st0",
    width: 33.12,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 423,
    className: "st0",
    width: 8.69,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 411,
    className: "st0",
    width: 19.19,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 412.68,
    className: "st0",
    width: 43.19,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 412.68,
    className: "st0",
    width: 6.33,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 416.91,
    className: "st0",
    width: 93.68,
    height: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M237.01,359.59H43.92c-3.15,0-5.71-2.56-5.71-5.71V82.45c0-3.15,2.56-5.71,5.71-5.71h193.1 c3.15,0,5.71,2.56,5.71,5.71v271.43C242.72,357.03,240.16,359.59,237.01,359.59z M43.92,77c-3.01,0-5.46,2.45-5.46,5.46v271.43 c0,3.01,2.45,5.46,5.46,5.46h193.1c3.01,0,5.46-2.45,5.46-5.46V82.45c0-3.01-2.45-5.46-5.46-5.46H43.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M453.31,359.59h-193.1c-3.15,0-5.71-2.56-5.71-5.71V82.45c0-3.15,2.56-5.71,5.71-5.71h193.1 c3.15,0,5.71,2.56,5.71,5.71v271.43C459.02,357.03,456.46,359.59,453.31,359.59z M260.21,77c-3.01,0-5.46,2.45-5.46,5.46v271.43 c0,3.01,2.45,5.46,5.46,5.46h193.1c3.01,0,5.46-2.45,5.46-5.46V82.45c0-3.01-2.45-5.46-5.46-5.46H260.21z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 289.69,
    y: 105.63,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 717.1623 301.4796)",
    className: "st1",
    width: 137.78,
    height: 90.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.49,
    y: 105.63,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 710.9939 301.4796)",
    className: "st2",
    width: 140.02,
    height: 90.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.69,
    y: 195.85,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 717.1623 409.414)",
    className: "st1",
    width: 137.78,
    height: 17.71
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.48,
    y: 195.85,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 696.9867 409.414)",
    className: "st2",
    width: 140.02,
    height: 17.71
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.27,
    y: 86.62,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 506.2368 -204.7572)",
    className: "st3",
    width: 78.46,
    height: 128.25
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "390.7,189.97 374.32,111.51 348.76,111.51 365.14,189.97  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M416.9,184.11c0.23,0,0.42-0.19,0.42-0.42v-68.35c0-0.23-0.19-0.42-0.42-0.42c-0.23,0-0.42,0.19-0.42,0.42 v68.35C416.48,183.92,416.66,184.11,416.9,184.11z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "359.65,189.97 343.27,111.51 333.3,111.51 349.69,189.97  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.52,
    y: 150.37,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 442.4858 -141.0062)",
    className: "st1",
    width: 78.46,
    height: 0.75
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "284.09,120.39 421.88,120.39 422.42,113.8 284.64,113.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "284.09,131.19 421.88,131.19 422.42,124.6 284.64,124.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "284.09,141.99 421.88,141.99 422.42,135.4 284.64,135.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "284.09,152.79 421.88,152.79 422.42,146.21 284.64,146.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "284.09,163.59 421.88,163.59 422.42,157.01 284.64,157.01  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "284.09,174.4 421.88,174.4 422.42,167.81 284.64,167.81  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 378.8,
    y: 338.58,
    className: "st1",
    width: 28.89,
    height: 5.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.31,
    y: 273.13,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 653.9484 677.3211)",
    className: "st1",
    width: 5.33,
    height: 131.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.84,
    y: 338.58,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 684.6346 682.8477)",
    className: "st6",
    width: 72.96,
    height: 5.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.8,
    y: 369.74,
    className: "st1",
    width: 28.89,
    height: 5.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.84,
    y: 369.74,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 684.6346 745.1809)",
    className: "st6",
    width: 72.96,
    height: 5.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.8,
    y: 276.24,
    className: "st1",
    width: 28.89,
    height: 5.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.84,
    y: 276.24,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 684.6346 558.1809)",
    className: "st6",
    width: 72.96,
    height: 5.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.8,
    y: 307.41,
    className: "st1",
    width: 28.89,
    height: 5.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.84,
    y: 307.41,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 684.6346 620.5143)",
    className: "st6",
    width: 72.96,
    height: 5.7
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 397.27,
    y: 273.13,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 799.8751 677.3211)",
    className: "st1",
    width: 5.33,
    height: 131.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.47,
    y: 273.13,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 752.2646 677.3211)",
    className: "st6",
    width: 5.33,
    height: 131.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.84,
    y: 273.13,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 617.0045 677.3211)",
    className: "st6",
    width: 5.33,
    height: 131.07
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 65.37,
    y: 298.3,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 185.3254 702.4955)",
    className: "st1",
    width: 54.58,
    height: 105.89
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "79.95,404.19 65.37,404.19 65.37,389.58 95.23,389.58  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.18,
    y: 298.3,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 482.9448 702.4955)",
    className: "st1",
    width: 54.58,
    height: 105.89
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.37,
    y: 298.3,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 292.2764 697.464)",
    className: "st3",
    width: 161.53,
    height: 100.86
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.33,404.19 226.9,404.19 226.9,389.58 197.05,389.58  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.68,
    y: 335.89,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 292.2764 697.0119)",
    className: "st2",
    width: 138.92,
    height: 25.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.68,
    y: 366.52,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 292.2764 758.2832)",
    className: "st2",
    width: 138.92,
    height: 25.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M103.08,338.58h86.11c2.53,0,4.58-2.05,4.58-4.58v-0.31H98.51v0.31 C98.51,336.54,100.56,338.58,103.08,338.58z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.68,
    y: 305.25,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 292.2764 635.7405)",
    className: "st2",
    width: 138.92,
    height: 25.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M103.08,307.95h86.11c2.53,0,4.58-2.05,4.58-4.58v-0.31H98.51v0.31C98.51,305.9,100.56,307.95,103.08,307.95 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M103.08,369.22h86.11c2.53,0,4.58-2.05,4.58-4.58v-0.31H98.51v0.31 C98.51,367.17,100.56,369.22,103.08,369.22z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 74.07,
    y: 105.63,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 285.9172 301.4796)",
    className: "st1",
    width: 137.78,
    height: 90.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.86,
    y: 105.63,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 279.7489 301.4796)",
    className: "st2",
    width: 140.02,
    height: 90.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.07,
    y: 195.85,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 285.9172 409.414)",
    className: "st1",
    width: 137.78,
    height: 17.71
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.86,
    y: 195.85,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 265.7415 409.414)",
    className: "st2",
    width: 140.02,
    height: 17.71
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.65,
    y: 86.62,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 290.6143 10.8653)",
    className: "st3",
    width: 78.46,
    height: 128.25
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "175.08,189.97 158.7,111.51 133.14,111.51 149.52,189.97  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M201.27,184.11c0.23,0,0.42-0.19,0.42-0.42v-68.35c0-0.23-0.19-0.42-0.42-0.42c-0.23,0-0.42,0.19-0.42,0.42 v68.35C200.85,183.92,201.04,184.11,201.27,184.11z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "144.03,189.97 127.65,111.51 117.68,111.51 134.06,189.97  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.9,
    y: 150.37,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 226.8632 74.6164)",
    className: "st1",
    width: 78.46,
    height: 0.75
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "68.47,120.39 206.25,120.39 206.79,113.8 69.01,113.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "68.47,124.1 206.25,124.1 206.79,117.52 69.01,117.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "68.47,127.82 206.25,127.82 206.79,121.23 69.01,121.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "68.47,131.53 206.25,131.53 206.79,124.95 69.01,124.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "68.47,135.25 206.25,135.25 206.79,128.66 69.01,128.66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "68.47,138.96 206.25,138.96 206.79,132.38 69.01,132.38  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 96.01,
    y: 241.97,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 196.7898 537.0394)",
    className: "st6",
    width: 4.76,
    height: 53.09
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.63,
    y: 241.94,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 194.5989 536.9658)",
    className: "st3",
    width: 1.35,
    height: 53.09
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.54,
    y: 241.94,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 197.5986 536.966)",
    className: "st3",
    width: 0.53,
    height: 53.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M80.76,298.3h35.26v0c0-2.45-1.99-4.44-4.44-4.44H85.21C82.75,293.86,80.76,295.85,80.76,298.3L80.76,298.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M89.83,274.93L89.83,274.93c0.75,0,1.37-0.62,1.37-1.37v-34.81c0-0.75-0.62-1.37-1.37-1.37l0,0 c-0.75,0-1.37,0.62-1.37,1.37v34.81C88.46,274.32,89.08,274.93,89.83,274.93z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "77.07,254.59 119.72,254.59 114.81,224.79 81.98,224.79  "
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple",
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M240.47,127.1c48.1,5.38,69.22-36.32,116.88-30.86c42.54,4.87,71.88,35.18,61.95,76.01 c-8.81,36.24-50.81,47.61-65.74,81.56c-15.83,35.99-28.1,74.79-75.9,87.32c-93.85,24.6-139.44-90.88-145.83-157.21 c-2.45-25.46-6.73-86.33,26.5-94.21C191.79,81.76,210.96,123.8,240.47,127.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M240.47,127.1c48.1,5.38,69.22-36.32,116.88-30.86c42.54,4.87,71.88,35.18,61.95,76.01 c-8.81,36.24-50.81,47.61-65.74,81.56c-15.83,35.99-28.1,74.79-75.9,87.32c-93.85,24.6-139.44-90.88-145.83-157.21 c-2.45-25.46-6.73-86.33,26.5-94.21C191.79,81.76,210.96,123.8,240.47,127.1z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Shadow_1_"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Window_No_Data"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.78,
    y: 224.17,
    transform: "matrix(0.9974 -0.0718 0.0718 0.9974 -16.4979 8.0942)",
    className: "st12",
    width: 1,
    height: 18.49
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.38,
    y: 252.15,
    transform: "matrix(0.9974 -0.0719 0.0719 0.9974 -18.0946 8.2692)",
    className: "st12",
    width: 1,
    height: 6.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M337.71,336.96H123.55c-4.84,0-9.09-3.96-9.44-8.81l-10.52-146.13c-0.35-4.84,3.33-8.81,8.17-8.81h214.16 c4.84,0,9.09,3.96,9.44,8.81l10.52,146.13C346.23,332.99,342.55,336.96,337.71,336.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M338.53,336.96H124.37c-4.84,0-9.09-3.96-9.44-8.81l-10.52-146.13c-0.35-4.84,3.33-8.81,8.17-8.81h214.16 c4.84,0,9.09,3.96,9.44,8.81l10.52,146.13C347.05,332.99,343.38,336.96,338.53,336.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M338.53,336.96H124.37c-4.84,0-9.09-3.96-9.44-8.81l-10.52-146.13c-0.35-4.84,3.33-8.81,8.17-8.81h214.16 c4.84,0,9.09,3.96,9.44,8.81l10.52,146.13C347.05,332.99,343.38,336.96,338.53,336.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M327.06,177.62H112.9c-0.24,0-0.48,0.01-0.72,0.03c-5.47,0.45-4.36,8.78,1.17,8.78h214.52 c5.53,0,5.44-8.33-0.1-8.78C327.54,177.63,327.3,177.62,327.06,177.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M118.48,182.02c0.08,1.12-0.76,2.02-1.87,2.02c-1.12,0-2.08-0.9-2.16-2.02c-0.08-1.11,0.76-2.02,1.87-2.02 S118.4,180.9,118.48,182.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M125.35,182.02c0.08,1.12-0.76,2.02-1.87,2.02c-1.12,0-2.08-0.9-2.16-2.02c-0.08-1.11,0.76-2.02,1.87-2.02 C124.3,180,125.27,180.9,125.35,182.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M132.21,182.02c0.08,1.12-0.76,2.02-1.87,2.02c-1.12,0-2.08-0.9-2.16-2.02c-0.08-1.11,0.76-2.02,1.87-2.02 S132.13,180.9,132.21,182.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M332.85,322.37h-204.9c-1.76,0-3.3-1.43-3.42-3.19l-8.65-120.17c-0.13-1.76,1.2-3.19,2.96-3.19h204.9 c1.76,0,3.3,1.43,3.42,3.19l8.65,120.17C335.94,320.94,334.62,322.37,332.85,322.37z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "246.53,276.59 243.19,230.27 233.09,224.19 205.28,224.19 209.06,276.59  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M246.53,277.08h-37.47c-0.25,0-0.46-0.2-0.48-0.45l-3.77-52.4c-0.01-0.13,0.04-0.27,0.13-0.36 c0.09-0.1,0.22-0.15,0.35-0.15h27.8c0.09,0,0.17,0.02,0.25,0.07l10.11,6.08c0.13,0.08,0.22,0.22,0.23,0.38l3.34,46.32 c0.01,0.13-0.04,0.27-0.13,0.37C246.79,277.02,246.66,277.08,246.53,277.08z M209.51,276.11h36.5l-3.28-45.55l-9.78-5.88H205.8 L209.51,276.11z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "243.19,230.27 233.09,224.19 236.8,232.25  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M236.8,232.73c-0.18,0-0.36-0.11-0.44-0.28l-3.71-8.06c-0.09-0.19-0.04-0.42,0.12-0.56 c0.16-0.14,0.39-0.16,0.57-0.05l10.11,6.08c0.16,0.1,0.25,0.28,0.23,0.47c-0.02,0.19-0.16,0.35-0.34,0.4l-6.4,1.98 C236.89,232.73,236.85,232.73,236.8,232.73z M234.19,225.42l2.88,6.24l4.96-1.53L234.19,225.42z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M220.97,247.8c0.08,1.17-0.8,2.12-1.96,2.12s-2.19-0.95-2.27-2.12c-0.08-1.17,0.8-2.12,1.96-2.12 S220.88,246.63,220.97,247.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M234.7,247.8c0.08,1.17-0.8,2.12-1.96,2.12c-1.17,0-2.19-0.95-2.27-2.12s0.8-2.12,1.96-2.12 C233.6,245.68,234.62,246.63,234.7,247.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M238.58,261.53c-0.25,0-0.46-0.19-0.48-0.45c-0.25-3.4-5.58-6.17-11.9-6.17c-4.18,0-7.94,1.24-9.81,3.25 c-0.83,0.89-1.21,1.85-1.14,2.86c0.02,0.27-0.18,0.5-0.45,0.52c-0.27,0.02-0.5-0.18-0.52-0.45c-0.09-1.27,0.39-2.51,1.4-3.59 c2.04-2.19,6.07-3.56,10.52-3.56c6.93,0,12.58,3.11,12.87,7.07c0.02,0.27-0.18,0.5-0.45,0.52 C238.6,261.53,238.59,261.53,238.58,261.53z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M213.17,243.51c-0.12,0-0.24-0.04-0.33-0.13c-0.2-0.18-0.21-0.49-0.03-0.68l2.12-2.29 c0.18-0.2,0.49-0.21,0.68-0.03c0.2,0.18,0.21,0.49,0.03,0.68l-2.12,2.29C213.43,243.46,213.3,243.51,213.17,243.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M237.58,243.51c-0.12,0-0.24-0.04-0.33-0.13l-2.45-2.29c-0.2-0.18-0.21-0.49-0.02-0.68 c0.18-0.2,0.49-0.21,0.68-0.02l2.45,2.29c0.2,0.18,0.21,0.49,0.02,0.68C237.84,243.46,237.71,243.51,237.58,243.51z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M202.26,286.95h2.26l3.26,4.33l-0.31-4.33h2.28l0.56,7.83h-2.28l-3.24-4.3l0.31,4.3h-2.28L202.26,286.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M211.33,290.87c-0.09-1.28,0.19-2.27,0.85-2.99c0.66-0.71,1.63-1.07,2.9-1.07c1.3,0,2.33,0.35,3.09,1.05 c0.76,0.7,1.18,1.68,1.27,2.94c0.07,0.92-0.03,1.67-0.3,2.25c-0.27,0.59-0.68,1.04-1.24,1.37c-0.56,0.33-1.27,0.49-2.14,0.49 c-0.88,0-1.62-0.14-2.22-0.42c-0.6-0.28-1.1-0.73-1.5-1.34C211.63,292.55,211.4,291.78,211.33,290.87z M213.76,290.88 c0.06,0.79,0.24,1.36,0.56,1.7c0.32,0.35,0.73,0.52,1.24,0.52c0.52,0,0.91-0.17,1.17-0.51c0.26-0.34,0.36-0.95,0.3-1.82 c-0.05-0.74-0.24-1.28-0.56-1.62c-0.32-0.34-0.74-0.51-1.25-0.51c-0.49,0-0.87,0.17-1.14,0.52 C213.8,289.51,213.7,290.08,213.76,290.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M224.15,286.95h3.6c0.71,0,1.29,0.1,1.74,0.29c0.45,0.19,0.83,0.47,1.14,0.83c0.31,0.36,0.55,0.78,0.71,1.26 c0.16,0.48,0.26,0.98,0.3,1.52c0.06,0.84,0.01,1.49-0.15,1.95c-0.16,0.46-0.39,0.85-0.71,1.16c-0.32,0.31-0.66,0.52-1.05,0.62 c-0.52,0.14-1,0.21-1.43,0.21h-3.6L224.15,286.95z M226.7,288.72l0.31,4.28h0.59c0.51,0,0.86-0.06,1.07-0.17 c0.21-0.11,0.36-0.31,0.46-0.59c0.1-0.28,0.13-0.73,0.08-1.36c-0.06-0.83-0.24-1.4-0.53-1.7c-0.29-0.31-0.75-0.46-1.38-0.46H226.7 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M237.45,293.49h-2.75l-0.29,1.29h-2.47l2.38-7.83h2.64l3.51,7.83h-2.53L237.45,293.49z M236.82,291.79 l-1.07-2.82l-0.65,2.82H236.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M239.37,286.95h7.36l0.14,1.93h-2.47l0.42,5.9h-2.42l-0.42-5.9h-2.47L239.37,286.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M252.37,293.49h-2.75l-0.29,1.29h-2.47l2.38-7.83h2.64l3.51,7.83h-2.53L252.37,293.49z M251.74,291.79 l-1.07-2.82l-0.65,2.82H251.74z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Character_1_"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataFull);
export default __webpack_public_path__ + "static/media/no_data_full.21163007360f8e6af208db1b168e8a1f.svg";
export { ForwardRef as ReactComponent };